import type { SVGProp } from './types';

export const wallet = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M19 7h-1V6c0-.79565-.3161-1.55871-.8787-2.12132C16.5587 3.31607 15.7956 3 15 3H5c-.79565 0-1.55871.31607-2.12132.87868C2.31607 4.44129 2 5.20435 2 6v12c0 .7956.31607 1.5587.87868 2.1213C3.44129 20.6839 4.20435 21 5 21h14c.7956 0 1.5587-.3161 2.1213-.8787C21.6839 19.5587 22 18.7956 22 18v-8c0-.79565-.3161-1.55871-.8787-2.12132C20.5587 7.31607 19.7956 7 19 7ZM5 5h10c.2652 0 .5196.10536.7071.29289C15.8946 5.48043 16 5.73478 16 6v1H5c-.26522 0-.51957-.10536-.70711-.29289C4.10536 6.51957 4 6.26522 4 6c0-.26522.10536-.51957.29289-.70711C4.48043 5.10536 4.73478 5 5 5Zm15 10h-1c-.2652 0-.5196-.1054-.7071-.2929C18.1054 14.5196 18 14.2652 18 14c0-.2652.1054-.5196.2929-.7071.1875-.1875.4419-.2929.7071-.2929h1v2Zm0-4h-1c-.7956 0-1.5587.3161-2.1213.8787C16.3161 12.4413 16 13.2044 16 14c0 .7956.3161 1.5587.8787 2.1213C17.4413 16.6839 18.2044 17 19 17h1v1c0 .2652-.1054.5196-.2929.7071-.1875.1875-.4419.2929-.7071.2929H5c-.26522 0-.51957-.1054-.70711-.2929C4.10536 18.5196 4 18.2652 4 18V8.83c.32127.11302.65943.17051 1 .17h14c.2652 0 .5196.10536.7071.29289.1875.18754.2929.44189.2929.70711v1Z"
      fill="currentColor"
    />
  </svg>
);
